export enum dayjsUnits {
  DAY = 'd',
  WEEK = 'w',
  MONTH = 'M',
}
